import React from 'react';
import { Link } from 'react-router-dom';
import owlLogo from '../Assets/logo icon transparent background.png';
import Navigation from '../components/shared/Navigation';

const FeatureSection = ({ title, features }) => (
  <div className="mb-12">
    <h3 className="text-xl font-bold text-[#1d2840] mb-4">{title}</h3>
    <ul className="space-y-3">
      {features.map((feature, index) => (
        <li key={index} className="flex items-start">
          <span className="text-[#3DA3DC] mr-2">✅</span>
          <span className="text-gray-600">{feature}</span>
        </li>
      ))}
    </ul>
  </div>
);

const FeaturesPage = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-white">
      <Navigation />
      <div className="pt-20">
        <div className="container mx-auto px-4 py-12">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-4xl font-bold text-[#1d2840] mb-6">Features</h1>
            
            <p className="text-gray-600 text-lg mb-12">
              At SuperOwl, we believe that AI conversational chat should be simple, affordable, and powerful for small and medium businesses. Our platform is designed to help you enhance customer interactions, automate responses, and compete with enterprise-level AI technology.
            </p>

            <h2 className="text-3xl font-bold text-[#1d2840] mb-8">🚀 Key Features</h2>
            
            <div className="space-y-12">
              <FeatureSection
                title="1. AI-Powered Conversations"
                features={[
                  'Engage customers with smart, human-like chat responses',
                  'Context-aware AI for natural and seamless conversations',
                  'Helps businesses improve customer engagement and efficiency'
                ]}
              />

              <FeatureSection
                title="2. Affordable & Credit-Based Pricing"
                features={[
                  'Free trial with limited AI conversation messages',
                  'Buy affordable credits as per your usage',
                  'No hidden charges, pay only for what you use'
                ]}
              />

              <FeatureSection
                title="3. Easy Integration & Setup"
                features={[
                  'Simple plug-and-play AI chat for websites & apps',
                  'Low-code or no-code setup for quick deployment',
                  'Easily integrates with your business workflow'
                ]}
              />

              <FeatureSection
                title="4. Smart Automation & Customization"
                features={[
                  'Automated FAQs & smart replies to reduce workload',
                  'Custom AI training to match your brand\'s voice',
                  'Pre-built templates for e-commerce, customer support, and more'
                ]}
              />

              <FeatureSection
                title="5. Scalable & Secure"
                features={[
                  'Cloud-based & scalable for growing businesses',
                  'End-to-end encryption for safe data handling',
                  'Regular updates to keep your chatbot fast & reliable'
                ]}
              />

              <FeatureSection
                title="6. 24/7 Customer Engagement"
                features={[
                  'Always available AI assistant for instant responses',
                  'Improves customer satisfaction & retention',
                  'Reduces manual effort and boosts productivity'
                ]}
              />
            </div>

            <div className="mt-16 bg-gray-50 p-8 rounded-lg border border-gray-200">
              <h2 className="text-2xl font-bold text-[#1d2840] mb-6">Why Choose SuperOwl?</h2>
              <ul className="space-y-3">
                <li className="flex items-center"><span className="text-[#3DA3DC] mr-2">✅</span>Designed for Small & Medium Businesses</li>
                <li className="flex items-center"><span className="text-[#3DA3DC] mr-2">✅</span>Cost-effective AI chat solution</li>
                <li className="flex items-center"><span className="text-[#3DA3DC] mr-2">✅</span>No technical expertise needed</li>
                <li className="flex items-center"><span className="text-[#3DA3DC] mr-2">✅</span>Quick setup & easy maintenance</li>
              </ul>
              <p className="mt-6 text-lg font-medium text-[#3DA3DC]">
                🚀 SuperOwl empowers you with AI technology to compete with big enterprises at a fraction of the cost!
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeaturesPage;
